<script>
  // @ts-check
  // eslint-disable-next-line no-unused-vars
  import * as Types from "../NewsLetter/newsLetterTypes";

  import Form from "./Form.svelte";
  import FormViewContainer from "./FormViewContainer.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = "";

  /**
   * @type { "split" | "stacked" }
   */
  export let layout = "split";

  /**
   * The theme of the form component
   * @type {import('../../utilities/themes.js').ThemeName}
   */
  export let theme = "lightGrey";

  /**
   * Optional featured image
   * @type {import('../../types/shared.js').Image} Image
   */
  export let featuredImage = undefined;

  /** The title of the form component
   * @type {string}
   * */
  export let title = "";

  /**
   * The description of the form component
   * @type {string}
   */
  export let description = "";

  /**
   * Optional prop for handling form submission natively
   *
   * @type {Types.FormProps}
   * */
  export let formProps;

  /**
   * A list of form fields
   * @type {import("../../molecules/FormFields/FormField.svelte").FormFieldProps[]}
   */
  export let formFields = [];

  /**
   * a list of field groups
   * @type {{label: string, formFields: import("../../molecules/FormFields/FormField.svelte").FormFieldProps[]}[]}
   */
  export let formFieldGroups = [];

  /** @type {(event: CustomEvent) => any}*/
  export let onSubmit = () => undefined;

  /**
   * Indicates whether the form is currently being submitted
   * @type {boolean}
   */
  export let isSubmitting = false;

  /**
   * Indicates whether the form submission was successful
   * @type {boolean}
   */
  export let isFormSubmitSuccess = false;

  /**
   * The error message to display when the form submission fails
   * @type {string}
   */
  export let formSubmitErrorMessage = "";
</script>

<FormViewContainer
  id="form-view-{id}"
  {layout}
  {theme}
  {title}
  {description}
  {featuredImage}
  {isFormSubmitSuccess}
>
  <svelte:fragment slot="main">
    <Form
      {id}
      {layout}
      {formProps}
      {formFields}
      {formFieldGroups}
      {isSubmitting}
      {formSubmitErrorMessage}
      on:formSubmit={onSubmit}
    />
  </svelte:fragment>
</FormViewContainer>
